export default __webpack_public_path__ + "static/media/MarieAuteroeche.22ad6bd3.png";